import TriggerConfigSerializer from 'eflex/serializers/trigger-config';

export default class IoTriggerConfigSerializer extends TriggerConfigSerializer {}
